import { Common } from 'src/domains/common/Common';
import { JackpotsSocket } from 'src/domains/casino/state/AppCasino/casino-sockets/jackpot-socket/JackpotsSocket';
import { Amount } from 'src_common/common/amount/Amount';
import { JackpotDetailsType } from 'src/domains/casino/state/AppCasino/casino-sockets/jackpot-socket/JackpotsDetailsModels';

const DREAM_DROP_NAME = 'Dream Drop';

export class JackpotWidgetState {
    private jackpotSocket: JackpotsSocket;

    public constructor(private readonly common: Common) {
        this.jackpotSocket = JackpotsSocket.get(this.common);
    }

    public get dreamDropJackpot(): Array<JackpotDetailsType> | null {
        const allDremDropJackpots = this.jackpotSocket.getAllJackpots();
        if (allDremDropJackpots === null) {
            return null;
        }
        const dreamDropJackpot = allDremDropJackpots.jackpotsList.jackpots.filter((jackpot) =>
            jackpot.name.includes(DREAM_DROP_NAME)
        );
        return dreamDropJackpot;
    }

    public get megaJackpot(): Amount | null {
        const allDremDropJackpots = this.dreamDropJackpot;
        if (allDremDropJackpots === null) {
            return null;
        }

        const megaJackpot = allDremDropJackpots.find((jackpot) => jackpot.name.toLowerCase().includes('mega'));
        if (megaJackpot === undefined) {
            return null;
        }

        return Amount.newOption(megaJackpot.amount);
    }

    public get maxiJackpot(): Amount | null {
        const allDremDropJackpots = this.dreamDropJackpot;
        if (allDremDropJackpots === null) {
            return null;
        }
        const maxiJackpot = allDremDropJackpots.find((jackpot) => jackpot.name.toLowerCase().includes('maxi'));
        if (maxiJackpot === undefined) {
            return null;
        }
        return Amount.newOption(maxiJackpot.amount);
    }

    public get midiJackpot(): Amount | null {
        const allDremDropJackpots = this.dreamDropJackpot;
        if (allDremDropJackpots === null) {
            return null;
        }
        const midiJackpot = allDremDropJackpots.find((jackpot) => jackpot.name.toLowerCase().includes('midi'));
        if (midiJackpot === undefined) {
            return null;
        }
        return Amount.newOption(midiJackpot.amount);
    }
}
